import { render, staticRenderFns } from "./SettingsDefaultImageAndDesc.vue?vue&type=template&id=1f92c914&scoped=true&"
import script from "./SettingsDefaultImageAndDesc.vue?vue&type=script&lang=ts&"
export * from "./SettingsDefaultImageAndDesc.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsDefaultImageAndDesc.vue?vue&type=style&index=0&id=1f92c914&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f92c914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f92c914')) {
      api.createRecord('1f92c914', component.options)
    } else {
      api.reload('1f92c914', component.options)
    }
    module.hot.accept("./SettingsDefaultImageAndDesc.vue?vue&type=template&id=1f92c914&scoped=true&", function () {
      api.rerender('1f92c914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/settings/SettingsDefaultImageAndDesc.vue"
export default component.exports